import React, { Fragment } from "react";
import { Link } from "@reach/router";
import WikiNavBar from "../components/navbar";
import TagChip from "../components/tag_chip";
import Footer from "../components/footer";
import RaceButton from "../components/race_button"
import Loading from "../components/loading";
import useFetchEtiquetas from "../hooks/use_fetch_etiquetas"
import FrontHeader from "../components/front_header";
import SearchArticulo from "../components/search-articulo";
import FadeIn from 'react-fade-in';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const HomePage = () => {
  const { etiquetas } = useFetchEtiquetas();

  return (
    <Fragment>
      <WikiNavBar showSearch={false} />
      <FadeIn>
        <div className="container">
          <FrontHeader>
            <h2>Bienvenido(a) a la</h2>
            <h1 style={{ color: 'white' }}>Biblioteca de Aerandir</h1>
            <p>Comienza tu aventura buscando en los artículos de nuestro Lore:</p>
            <br />

              <OverlayTrigger
                trigger="click"
                placement="top"
                overlay={<Tooltip id={`search-tooltip`}>
                  Tip: Puedes incluir etiquetas como #raza para filtrar tu búsqueda.
              </Tooltip>}>
              <center>
                <SearchArticulo wider center />
                </center>
              </OverlayTrigger>

            <br />
            <br />
          </FrontHeader>
          <div style={{ height: 20 }} />
          <br />
          <h3>Las 8 Razas</h3>
          <p>
            Un buen punto de partida para conocer nuestro lore es visitar los
            artículos de las 8 razas a las que los personajes pueden pertenecer:
        </p>
          <RaceButton raza="Bio-Cibernéticos" />
          <RaceButton raza="Brujos" />
          <RaceButton raza="Dragones" />
          <RaceButton raza="Elfos" />
          <RaceButton raza="Hombres Bestia" />
          <RaceButton raza="Humanos" />
          <RaceButton raza="Licántropos" />
          <RaceButton raza="Vampiros" />
          <br />
          <br />
          <h3>Artículos Importantes</h3>
          <p>
            Los siguientes artículos han sido seleccionados por constituir importantes puntos de partida para conocer nuestro foro y sus posibilidades. Cada uno te introducirá en una temática que luego puedes profundizar:
        </p>
          <p>
            <Link to='/articulo/sistema_de_habilidades'>Sistema de Habilidades</Link>{', '}
            <Link to='/articulo/tradiciones'>Tradiciones</Link>{'. '}
          </p>
          <h3>Etiquetas</h3>
          <p>
            Las siguientes etiquetas agrupan el contenido de esta biblioteca.
            Explóralas para encontrarte con distintos artículos de la misma
            temática.
        </p>
          {etiquetas ? etiquetas.map((tag) => (
            <TagChip key={tag} tag={tag} />
          )) : <Loading />}
          <br />
          <br />
        </div>
      </FadeIn>
      <Footer />
    </Fragment>
  );
};

export default HomePage;
